import type { ReactNode } from "react";

export function NoticeMessage({ children }: { children: ReactNode }) {
  return (
    <p className="px-2 py-6 text-center font-body text-body-3 leading-[1.4] text-text-secondary">
      {children}
    </p>
  );
}
